import React from "react";
import { Form, Row, Col, Divider, Typography, Select, Input, DatePicker } from "antd";
import {
    c_TipoDeComprobante,
    c_FormaPago,
    c_Exportacion,
} from "../../../SATCatalogos/index";

const { Title } = Typography;
const { Option } = Select;

const SERIES = [
    { value: process.env.REACT_APP_SPOT_SERIE, label: "SPOT" },
    { value: process.env.REACT_APP_VMI_FACTURA_SERIE, label: "Factura de Almacen (VMI)" },
    { value: process.env.REACT_APP_COMPROBANTE_SERIE, label: "Comprobante de Pago" },
    { value: process.env.REACT_APP_NOTA_CREDITO, label: "Nota de Crédito" },
];

const DocumentoFiscalSection = (props) => {

    const { tipoFactura } = props

    const renderCampo = !(tipoFactura === "PE")
    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5} className="mb-1">
                    Información del Documento Fiscal
                </Title>
            </Row>
            <Row gutter={16}>
                <Col xs={20} md={12}>
                    <Form.Item
                        name="Serie"
                        label="Serie"
                        rules={[{ required: true, message: "Ingrese la serie de la factura." }]}
                    >
                        <Select>
                            {SERIES.map(({ value, label }) => (
                                <Option key={value} value={value}>
                                    <strong>{value}</strong> - {label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name="Folio"
                        label="Folio"
                        rules={[{ required: true, message: "Ingrese el folio" }]}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name="Fecha"
                        label="Fecha de Emisión"
                        rules={[{ required: true, message: "Ingrese la Fecha" }]}
                    >
                        <DatePicker showTime className="width-100" />
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name="TipoDeComprobante"
                        label="Tipo De Comprobante"
                        rules={[{ required: true, message: "Ingrese el Tipo de Comprobante" }]}
                    >
                        <Select showSearch optionFilterProp="filter">
                            {c_TipoDeComprobante.map(({ tipo_comprobante, descripción }) => (
                                <Option
                                    key={tipo_comprobante}
                                    filter={`${tipo_comprobante} ${descripción}`}
                                    value={tipo_comprobante}
                                >
                                    <strong>{tipo_comprobante}</strong> - {descripción}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                {renderCampo && <Col xs={20} md={12}>
                    <Form.Item name="FormaPago" label="Forma de Pago">
                        <Select>
                            <Option value={null}>SIN FORMA DE PAGO</Option>
                            {c_FormaPago.map(({ forma_pago, descripcion }) => (
                                <Option key={forma_pago} value={forma_pago}>
                                    <strong>{forma_pago}</strong> - {descripcion}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>}
                {renderCampo && <Col xs={20} md={12}>
                    <Form.Item
                        name="MetodoPago"
                        label="Método de Pago"
                        rules={[{ required: true, message: "Ingrese el Método de Pago" }]}
                    >
                        <Select>
                            <Option value="PUE">
                                <strong>PUE</strong> - Pago en Una sola Exhibición
                            </Option>
                            <Option value="PPD">
                                <strong>PPD</strong> - Pago en Parcialidades o Diferido
                            </Option>
                        </Select>
                    </Form.Item>
                </Col>}
                <Col xs={20} md={12}>
                    <Form.Item
                        name="Exportacion"
                        label="Exportacion"
                        rules={[{ required: true, message: "Ingrese el Tipo de Exportación" }]}
                    >
                        <Select showSearch optionFilterProp="filter">
                            {c_Exportacion.map(({ exportacion, descripción }) => (
                                <Option key={exportacion} value={exportacion}>
                                    <strong>{exportacion}</strong> - {descripción}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={20} md={12}>
                    <Form.Item
                        name="LugarExpedicion"
                        label="Lugar Expedicion (C.P.)"
                        rules={[{ required: true, message: "Ingrese un código postal" }]}
                    >
                        <Input className="width-100" />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default DocumentoFiscalSection;
